import { yemboApiCall } from './_yemboApiCall';

// biome-ignore lint/suspicious/noExplicitAny: legacy API action interface
type ApiAction = Record<string, any>;

export const getActivities = async (action: ApiAction): Promise<unknown> =>
  Promise.resolve({ activities: [], totalEntries: 0 });
export const getActivitiesTotal = async (action: ApiAction): Promise<unknown> => Promise.resolve({ totalCount: 0 });

export const postNoteApi = async (action: ApiAction): Promise<unknown> =>
  await yemboApiCall({ method: 'post', url: 'note', ...action });
export const putNoteApi = async (action: ApiAction): Promise<unknown> =>
  await yemboApiCall({ method: 'put', url: 'note', ...action });
export const deleteNoteApi = async (action: ApiAction): Promise<unknown> =>
  await yemboApiCall({ method: 'delete', url: 'note', ...action });

export const postTaskApi = async (action: ApiAction): Promise<unknown> =>
  await yemboApiCall({ method: 'post', url: 'task', ...action });
export const putTaskApi = async (action: ApiAction): Promise<unknown> =>
  await yemboApiCall({ method: 'put', url: 'task', ...action });
export const deleteTaskApi = async (action: ApiAction): Promise<unknown> =>
  await yemboApiCall({ method: 'delete', url: 'task', ...action });

export const putCallApi = async (action: ApiAction): Promise<unknown> =>
  await yemboApiCall({ method: 'put', url: 'call', ...action });
export const deleteCallApi = async (action: ApiAction): Promise<unknown> =>
  await yemboApiCall({ method: 'delete', url: 'call', ...action });

export const getTextThreadApi = async (action: ApiAction): Promise<unknown> =>
  await yemboApiCall({ method: 'get', url: 'text-thread', ...action });
export const putTextThreadApi = async (action: ApiAction): Promise<unknown> =>
  await yemboApiCall({ method: 'put', url: 'text-thread', ...action });

export const postTextMessageApi = async (action: ApiAction): Promise<unknown> =>
  await yemboApiCall({ method: 'post', url: 'text-message', ...action });
